import type { ZoomShellSize } from "./types"

export function getZoomShellDimensions(
  baseWidth: number,
  baseHeight: number,
  scale: number,
  rotateDeg: number,
): ZoomShellSize {
  const safeScale = Number.isFinite(scale) && scale > 0 ? scale : 1
  const safeWidth = Math.max(0, baseWidth)
  const safeHeight = Math.max(0, baseHeight)
  const normalizedRotate = ((rotateDeg % 360) + 360) % 360
  const swapped = normalizedRotate === 90 || normalizedRotate === 270

  return {
    width: Math.round((swapped ? safeHeight : safeWidth) * safeScale * 1000) / 1000,
    height: Math.round((swapped ? safeWidth : safeHeight) * safeScale * 1000) / 1000,
  }
}
